import { EmergencyNotificationState } from './useEmergencyNotification';

export const shouldDispatchDismiss = (
   previousType: EmergencyNotificationState['type'] | undefined,
   currentType: EmergencyNotificationState['type'],
   previousNotificationId: number | null | undefined
): previousNotificationId is number => {
   return (
      previousType !== 'idle' &&
      currentType === 'idle' &&
      previousNotificationId !== null &&
      previousNotificationId !== undefined
   );
};
